module.exports = __webpack_public_path__ + "static/media/anc3kz.c9e8643e.pdf";